import { render, staticRenderFns } from "./ps-btn-cell-renderer.vue?vue&type=template&id=89f1f8de&scoped=true&"
import script from "./ps-btn-cell-renderer.vue?vue&type=script&lang=js&"
export * from "./ps-btn-cell-renderer.vue?vue&type=script&lang=js&"
import style0 from "./ps-btn-cell-renderer.vue?vue&type=style&index=0&id=89f1f8de&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "89f1f8de",
  null
  
)

export default component.exports